import { ISchedule } from '../schedule';
import { ISession, MultipleCommunications } from '../session';

export enum SDOHModuleKey {
  Housing = 'housing',
  Food = 'food',
  Transportation = 'transportation',
  Utilities = 'utilities',
  Safety = 'safety',
  FinancialStrain = 'financialStrain',
  Employment = 'employment',
  Support = 'support',
  HealthLiteracy = 'healthLiteracy',
  // Childcare = 'childcare', not supported
  Insurance = 'insurance',
  UrgentNeeds = 'urgentNeeds'
}

export enum SDOHModuleKeyPrefix {
  Housing = '_housing',
  Food = '_food',
  Transportation = '_transportation',
  Utilities = '_utilities',
  Safety = '_safety',
  FinancialStrain = '_financialStrain',
  Employment = '_employment',
  Support = '_support',
  HealthLiteracy = '_healthLiteracy',
  // Childcare = '_childcare', not supported
  Insurance = '_insurance',
  UrgentNeeds = '_urgentNeeds'
}

export const SDOHModuleKeyToPrefix: Partial<
  Record<SDOHModuleKey, SDOHModuleKeyPrefix>
> = {
  [SDOHModuleKey.Housing]: SDOHModuleKeyPrefix.Housing,
  [SDOHModuleKey.Food]: SDOHModuleKeyPrefix.Food,
  [SDOHModuleKey.Transportation]: SDOHModuleKeyPrefix.Transportation,
  [SDOHModuleKey.Utilities]: SDOHModuleKeyPrefix.Utilities,
  [SDOHModuleKey.Safety]: SDOHModuleKeyPrefix.Safety,
  [SDOHModuleKey.Employment]: SDOHModuleKeyPrefix.Employment,
  [SDOHModuleKey.Support]: SDOHModuleKeyPrefix.Support,
  [SDOHModuleKey.HealthLiteracy]: SDOHModuleKeyPrefix.HealthLiteracy,
  [SDOHModuleKey.FinancialStrain]: SDOHModuleKeyPrefix.FinancialStrain,
  [SDOHModuleKey.Insurance]: SDOHModuleKeyPrefix.Insurance,
  [SDOHModuleKey.UrgentNeeds]: SDOHModuleKeyPrefix.UrgentNeeds
};

export interface SDOHModule {
  key: string;
  mode: 'month' | 'year';
  daysOfMonth?: number[];
  date?: string;
  isActive: boolean;
  isDiscontinued?: boolean;
  discontinuedAt?: Date;
  lastSessionAt?: Date;
}

export interface IEpxSDOHSchedule extends ISchedule {
  daysOfMonth?: number[];
  date?: string;
  days: never;
  modules: Record<SDOHModuleKey, SDOHModule>;
}

export type SDOHChildMapping = {
  [SDOHModuleKeyPrefix.Housing]?: IEpxSDOHHousing;
  [SDOHModuleKeyPrefix.Food]?: IEpxSDOHFood;
  [SDOHModuleKeyPrefix.Transportation]?: IEpxSDOHTransportation;
  [SDOHModuleKeyPrefix.Utilities]?: IEpxSDOHUtilities;
  [SDOHModuleKeyPrefix.Safety]?: IEpxSDOHSafety;
  [SDOHModuleKeyPrefix.Employment]?: IEpxSDOHEmployment;
  [SDOHModuleKeyPrefix.Support]?: IEpxSDOHSupport;
  [SDOHModuleKeyPrefix.HealthLiteracy]?: IEpxSDOHHealthLiteracy;
  [SDOHModuleKeyPrefix.FinancialStrain]?: IEpxSDOHFinancialStrain;
  [SDOHModuleKeyPrefix.Insurance]?: IEpxSDOHInsurance;
  [SDOHModuleKeyPrefix.UrgentNeeds]?: IEpxSDOHUrgentNeeds;
};

export interface IEpxSDOH
  extends ISession<IEpxSDOHSchedule>, MultipleCommunications, SDOHChildMapping {
  modules: SDOHModuleKey[];
  isComplete: boolean;
  currentModule?: string;
  currentModuleId?: number;
}

export interface IEpxSDOHModule extends ISession<IEpxSDOHSchedule> {
  isComplete: boolean;
  parentId?: number;
  parent?: IEpxSDOH;
}

export interface IEpxSDOHHousing extends IEpxSDOHModule {
  security?: number;
  pests?: number;
  displaced?: number;
}

export interface IEpxSDOHFood extends IEpxSDOHModule {
  scarcity?: number;
  ration?: number;
}

export interface IEpxSDOHTransportation extends IEpxSDOHModule {
  reliable?: number;
}

export interface IEpxSDOHUtilities extends IEpxSDOHModule {
  shutOffService?: number;
}

export interface IEpxSDOHSafety extends IEpxSDOHModule {
  unsafe?: number;
  wantToConnect?: boolean;
}

export interface IEpxSDOHEmployment extends IEpxSDOHModule {
  unemployment?: number;
}

export interface IEpxSDOHSupport extends IEpxSDOHModule {
  isolation?: number;
  help?: number;
}

export interface IEpxSDOHHealthLiteracy extends IEpxSDOHModule {
  understanding?: number;
}

export interface IEpxSDOHFinancialStrain extends IEpxSDOHModule {
  strain?: number;
}

export interface IEpxSDOHInsurance extends IEpxSDOHModule {
  uninsured?: number;
}

export interface IEpxSDOHUrgentNeeds extends IEpxSDOHModule {
  issues?: string[];
}
